module.exports = __webpack_public_path__ + "static/nespresso-banner-b1813f514205ab1d50bf70a0931bad22.jpg";